// export default "http://192.168.130.197:8099/";
// export default "http://192.168.130.223:8099/"; //晨亮
export default "http://120.77.37.10:7503/"; //开发调试
// export default "http://bms.car900.com/"; //环境
// export default "http://192.168.100.226:8099/";//温志发
// export default "http://192.168.130.208:8099/"; //赵阳
// export default "http://120.79.38.48:7999/";//测试环境
// export default "http://192.168.100.179:8099";//威铭
// export default "http://112.74.74.215:80";//测试环境
// export default "http://120.77.26.175:8099/";//旧版测试环境
